import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What is AR/VR and how do they differ?",
    category: "Technology",
    description:
      "AR overlays digital elements onto the real world, while VR creates a fully immersive virtual environment. AR enhances real surroundings, whereas VR replaces them entirely, offering deeper immersion and interactive virtual experiences.",
  },
  {
    title: "What tools and software are used in AR/VR development?",
    category: "Trending",
    description:
      "AR/VR developers commonly use Unity, Unreal Engine, Blender, ARCore, ARKit, and Oculus SDKs. These tools help create interactive 3D environments, virtual objects, animations, and immersive user experiences across different devices.",
  },
  {
    title: "What industries use AR/VR the most?",
    category: "Design",
    description:
      "AR/VR is heavily used in gaming, education, healthcare, retail, real estate, manufacturing, training simulations, and entertainment. These industries rely on immersive technology for visualization, training, marketing, and interactive customer experiences.",
  },
  {
    title: "Is AR/VR good for a long-term career?",
    category: "Design",
    description:
      "Yes, AR/VR is rapidly growing across industries. Skills in immersive technology, real-time rendering, and interaction design open opportunities in gaming, training, design, simulation, and enterprise solutions, offering strong long-term career potential.",
  },
  {
    title: "How important is UI/UX in AR/VR applications?",
    category: "Design",
    description:
      "UI/UX is extremely important in AR/VR because users navigate 3D spaces. Designers must consider comfort, interaction flow, depth, accessibility, and natural hand or gaze-based controls to ensure immersive, intuitive experiences.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
